import { render, staticRenderFns } from "./OrdersWithProducts.vue?vue&type=template&id=edbbf8dc&"
import script from "./OrdersWithProducts.vue?vue&type=script&lang=js&"
export * from "./OrdersWithProducts.vue?vue&type=script&lang=js&"
import style0 from "./OrdersWithProducts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports